var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ic-form__address" }, [
    _c("fieldset", [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "street",
                name: "address.street",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_street"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: {
                          id: "street",
                          autocomplete: "address-line1",
                          maxlength: "50",
                          capitalize: "1",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.street,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "street", $$v)
                          },
                          expression: "data.street",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "streetNo",
                name: "address.streetNo",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_streetNo"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: {
                          id: "streetNo",
                          autocomplete: "address-line2",
                          maxlength: "10",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.streetNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "streetNo", $$v)
                          },
                          expression: "data.streetNo",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "apartment",
                name: "address.apartment",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_apartment"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: {
                          id: "apartment",
                          autocomplete: "address-line3",
                          maxlength: "10",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.apartment,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "apartment", $$v)
                          },
                          expression: "data.apartment",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-3" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "zip",
                name: "address.zip",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_zip"),
                labelWidth: 4,
                controlWidth: 2,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInputZip", {
                        attrs: {
                          id: "zip",
                          autocomplete: "postal-code",
                          maxlength: "30",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.zip,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "zip", $$v)
                          },
                          expression: "data.zip",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-9 form-padding-left" },
          [
            _c("IcFormRowWrapper", {
              attrs: {
                rowElement: "IcFormRow",
                id: "city",
                name: "address.city",
                aria: _vm.$t("aria_required"),
                label: _vm.$t("label_city"),
                labelWidth: 4,
                controlWidth: 8,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ validator }) {
                    return [
                      _c("IcInput", {
                        attrs: {
                          id: "city",
                          autocomplete: "address-level2",
                          maxlength: "30",
                          capitalize: "1",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.emitInput(_vm.data, validator)
                          },
                        },
                        model: {
                          value: _vm.data.city,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "city", $$v)
                          },
                          expression: "data.city",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("legend", [_c("h3", [_vm._v("Adres korespondencyjny")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }